import React from "react";
import { AssessmentConfiguration } from "src/types/coaching/assessmentConfiguration";

export type ScoreCardEditMode = 'create' | 'rename' | 'delete' | 'clone' | null | undefined;


export interface EditChange {
  id: string;
  mode: 'rename' | 'clone' | 'delete';
  value: string | AssessmentConfiguration | null;
}

export interface ScoreCardsContextProps {
  scorecard: AssessmentConfiguration | null;
  editMode: ScoreCardEditMode;
  edits: EditChange[];
  showPreview: boolean;

  onEditChanges: (value: EditChange) => void;
  onEditModeChange: (value: ScoreCardEditMode) => void;
  onClosePreview?: () => void;
  onSetDefault?: (scorecard: AssessmentConfiguration) => void;
}

export const ScoreCardsContext =
  React.createContext<ScoreCardsContextProps>({
    scorecard: null,
    editMode: null,
    edits: [],
    showPreview: false,

    onEditChanges: () => { },
    onEditModeChange: () => { },
    onClosePreview: () => { },
    onSetDefault: () => { },
  });